import { chatbotHost } from '../../apiConfig';

export const documentConfig = {
  HEALTH_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/document/health`
    : '',
  UPLOAD_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/document/upload`
    : '',
  STATUS_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/document/status`
    : '',
  STATUS_ALL_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/document/status_all`
    : '',
  DELETE_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/document/delete`
    : '',
};
